import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { variablesStore, type VariablesStoreState } from './VariablesStore';
import { selectData, selectById } from '../selectors.ts';
import { useAttach } from '../useAttach';

export function useVariablesData() {
  useAttach(variablesStore, 'useVariablesData');
  return useStoreWithEqualityFn(variablesStore.store, selectData, shallow);
}
useVariablesData.store = variablesStore;

export function useVariablesById() {
  useAttach(variablesStore, 'useVariablesById');
  return useStoreWithEqualityFn(variablesStore.store, selectById, shallow);
}
useVariablesById.store = variablesStore;

export function useVariable({ variableId }: { variableId: string }) {
  useAttach(variablesStore, 'useVariable');

  const select = useCallback(
    (state: VariablesStoreState) => {
      return {
        variable: state.byId?.[variableId] ?? null,
        variableInstance: state.data?.[variableId] ?? null,
      };
    },
    [variableId]
  );

  return useStoreWithEqualityFn(variablesStore.store, select, shallow);
}
useVariable.store = variablesStore;

export function useVariablesAttach() {
  useAttach(variablesStore, 'useVariablesAttach');
}
useVariablesAttach.store = variablesStore;
